module.exports = "\r\n<h4>{{assignSelectedLanguageValue?.myIdAgent}} {{dataSettingService.cZentrixAgentID}} {{status}}</h4>"


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/dashboard-user-id/dashboardUserId.html
// module id = ../../../../../src/app/dashboard-user-id/dashboardUserId.html
// module chunks = 0